import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ModalNames } from "features/modals/types"
import { useAppDispatch } from "integrations/redux/hooks"
import { showGlobalModal } from "runlevel/actions"

export const SidePanelTryAddOns = () => {
    return (
        <div className="mx-3 my-4 flex flex-col gap-5 items-center flex-shrink-0">
            <small className="text-center text-gray-300 select-none">
                Try our powerful add-ons for free
                <br />
                with our pre-loaded sample data.
            </small>
            <ButtonTryAddOns />
        </div>
    )
}

const ButtonTryAddOns = () => {
    const dispatch = useAppDispatch()
    return (
        <button
            className={classNames(
                "rounded-full py-1.5 px-3 flex items-center justify-center gap-1 relative w-full group/button select-none",
                "border border-lazeryellow/50",
                "hover:border-lazeryellow hover:bg-black-900",
                "active:border-gray-0 active:bg-black-900"
            )}
            onClick={() => {
                dispatch(initializeCenterModalForComponentAction(ModalNames.TryOurAddOnsModal))
                dispatch(showGlobalModal())
            }}
        >
            <Icons.SmallIcon Icon={Icons.AwardStar} className="text-lazeryellow" />
            <h5 className="text-gray-100 group-hover/button:text-gray-0">Try our Add-ons</h5>
        </button>
    )
}
